import React from 'react';
import { Modal } from 'react-bootstrap';

const styles = {
  modalHeader: {
    borderBottom: 'none',
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 0,
  },
  modalBody: {
    paddingTop: 6,
    paddingLeft: 12,
    paddingRight: 12,
    paddingBottom: 14,
  },
};

// Thin shell around the element library. Selection is click-to-add (each row
// inserts its element and closes), so there's no separate Insert footer.
const ElementSelectorModal = ({
  title = 'Add an element',
  show,
  onClose,
  children,
}) => {
  return (
    <Modal show={show} onHide={onClose} backdrop keyboard className="un-pe-amodal">
      <Modal.Header style={styles.modalHeader} closeButton>
        <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={styles.modalBody}>
        {children}
      </Modal.Body>
    </Modal>
  );
};

export default ElementSelectorModal;